import React from 'react';
import { Grid, Typography } from '@mui/material';

function Section({ children, label, labelProps, header, headerProps, secondaryHeader, secondaryHeaderProps, contentProps, ...rest }) {
    return (
        <Grid container {...rest}>
            {label && (
                <Typography sx={{ marginY: '16px', ...labelProps?.sx }} variant="h5" {...labelProps}>
                    {label}
                </Typography>
            )}
            {header && (
                <Grid item xs={headerProps?.xs}>
                    <Typography sx={{ marginY: '16px', ...headerProps?.sx }} variant="h6" {...headerProps}>
                        {header}
                    </Typography>
                </Grid>
            )}
            {secondaryHeader && (
                <Grid item xs={secondaryHeaderProps?.xs}>
                    <Typography sx={{ marginY: '16px', ...secondaryHeaderProps?.sx }} variant="h6" {...secondaryHeaderProps}>
                        {secondaryHeader}
                    </Typography>
                </Grid>
            )}
            <Grid container spacing={1} alignItems="center" {...contentProps}>
                {children}
            </Grid>
        </Grid>
    );
}

export default Section;
